import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c2bc7e1c")

_pushScopeId("data-v-c2bc7e1c")
const _hoisted_1 = { class: "background-iframe" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("iframe", {
      src: _ctx.url,
      onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.iframeLoad && _ctx.iframeLoad(...args))),
      id: _ctx.id,
      scrolling: "no",
      style: {"width":"100%","height":"100%"}
    }, null, 40, ["src", "id"])
  ]))
})